import React, { useContext, useEffect, useState } from "react";
import Head from "next/head";
import { Header } from "./Header/web";
import "./styles.less";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { useGoogleTagManager } from "shared-components/GlobalHooks/web/GoogleTagManager.hook";
import { ListingStructDataJson } from "shared-components/ViewFragments/SearchPage/ListingStructDataJson";
import { SearchResultsPagination } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/web";
import { Listings } from "./Listings";
import { Button } from "shared-components/Components/Buttons/web";
import dynamic from "next/dynamic";
import { ButtonMapToggle } from "shared-components/ViewFragments/SearchResults/Content/MapButton/web";
import { Order } from "shared-components/Components/Filters/Order/web";
import { SearchResultDisplay } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/ResultDisplay/web";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { H1 } from "shared-components/Components/SEO/H1/web";
import cookie from "js-cookie";
import { useUser } from "shared-components/Components/User/User.hook";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { PicHomeFooter } from "shared-components/ViewFragments/Footer/PicHomeFooter/web";
import TopBarFilters from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/web";
import Ad from "src/hooks/ads/Ad";
import { ADS_NAME, ADS_PREFIX, DFP_NETWORK_ID } from "src/constants/ads";
import useListingTags from "src/hooks/listingTags/useListingTags";
import { FilterIcon } from "shared-components/Components/CustomIcons/FilterIcon/web";
import { isProject } from "@Utils/Functions";
import { useRoutesContext } from "src/contexts/RoutesContext";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

//@ts-ignore
const SearchResultsMap = dynamic(
	() =>
		import(
			/* webpackChunkName: "SearchResultsMap" */ "shared-components/ViewFragments/SearchResults/Content/SearchResultsMap/web"
		),
	{ ssr: false, loading: () => <></> }
);
const SiderBar = dynamic(() => import(/* webpackChunkName: "SiderBar" */ "./SiderBar"), {
	ssr: false,
	loading: () => <div className="search-filters">

	</div>,
});

const IcBuscaPorTi = dynamic(() => import("shared-components/Components/PopUps/IcBuscaPorTi/web"), {
	ssr: false,
	loading: () => <div className="search-filters"></div>,
});

export const SearchPageLayout_v3 = ({ fetchResult }) => {

	const { filters } = useFilters();
	const { setListingTags } = useListingTags();
	const GTM = useGoogleTagManager();
	const [map, setMap] = useState<boolean>(false);
	const data = fetchResult
	const [error, setError] = useState(false);
	const screen = useWindowSize();
	const [sider, setSider] = useState(false);
	const { user } = useUser();
	const RoutesContext = useRoutesContext();
	const {country_code } = useContext(ConfigStateContext)
	const loading = RoutesContext.routes.loading
	const [modal, setModal] = useState(false);
	const idealFilters = ["operation_type_id", "property_type_id", "maxPrice", "bedrooms"];
	let noIndex = false;
	let noFollow = false;

	if (
		(data?.searchFast?.data && data?.searchFast?.data?.length == 0) ||
		(filters?.neighborhood_id && filters?.neighborhood_id?.length > 2) ||
		(filters?.property_type_id && filters?.property_type_id?.length > 2) ||
		(filters?.bedrooms && filters?.bedrooms.length > 1) ||
		(filters?.order && [4, 5].includes(filters?.order))
	) {
		console.warn("Page with: noindex, nofollow");
		noIndex = true;
		noFollow = true;
	} else if (data?.searchFast?.data && data?.searchFast?.data?.length <= 10) {
		console.warn("Page with: nofollow");
		noIndex = false;
		noFollow = true;
	} else {
		noIndex = false;
		noFollow = false;
	}

	useEffect(() => {
		const dataTags = fetchResult?.searchFast?.data.map((property) => (
			{
				id: property.id,
				seaDistanceName: property.seaDistanceName,
				isProject: isProject(property),
				highlight: property.highlight,
				owner: property.owner,
				isExternal: property.isExternal,
				tour3d: property.tour3d,
				link: property.link,
				legacy_propID: property.legacy_propID,
				title: property.title,
				tag: property.tag
			}
		))

		setListingTags(dataTags)
		RoutesContext.setRoutes({ loading: false })
	}, [data]);

	useEffect(() => {
		if (data && data.length > 0) {
			GTM.Event({
				name: "searchresults",
				data: {
					listing_id: data.map(p => p.id),
					listing_totalvalue: data.map(p => p.price),
					listing_pagetype: "searchresults",
				},
			});
		}
	}, [data]);

	useEffect(() => {
		const cookieModal = cookie.get("modalBuscaPorTi");
		if (!modal && typeof cookieModal === "undefined") {
			const filtersKeys = Object.keys(filters);
			const hasIdealFilters = idealFilters.every(elem => filtersKeys.includes(elem));
			if (filters.page >= 2 && hasIdealFilters) {
				let showModal = true;
				if (user.data.me && user.data.me.searchAlerts) {
					(user.data.me.searchAlerts ?? []).map(search => {
						const searchStringify = JSON.stringify(search.filters);
						const filtersAsArray = Object.entries(filters).filter(
							filter =>
								filter[0] !== "page" &&
								filter[0] !== "order" &&
								filter[0] !== "map_bounds"
						);
						const finalFiltersObject = Object.fromEntries(filtersAsArray);
						const filtersStringify = JSON.stringify(finalFiltersObject);
						if (showModal !== true) {
							if (searchStringify === filtersStringify) showModal = false;
							else showModal = true;
						}
					});
				}
				setModal(showModal);
			}
		}
	}, [filters, user]);

	const handleClose = () => {
		cookie.set("modalBuscaPorTi", "Si", { expires: 7 });
	};

	const affixedMobileButtons = (
		<div className={`search-results-affix-bar`}>
			<div className={!map ? "filters-affix-bar" : "filters-affix-bar-map"}>
				{!map && <Order />}
				<ButtonMapToggle map={map} setMap={setMap} />
				<Button
				className={!map? "open_filter_btn order-filter-btn"	: "open_filter_btn_map order-filter-btn-map"}
					type="secondary"
					onClick={() => {
						setSider(true);
					}}>
					<FilterIcon /> Filtrar
				</Button>
			</div>
		</div>
	);

	const topContent = (
		<div className={!map ? "topContent-wrap" : "topContent-wrapMap"}>
			<div className="search-result-text-info">
				{!map && <H1 total={data?.searchFast?.paginatorInfo.total} />}
				{!screen.xs && !map && <BreadCrumbs />}
				{!map && data?.searchFast?.paginatorInfo && (
					<SearchResultDisplay
						loading={loading}
						error={error}
						paginatorInfo={data?.searchFast?.paginatorInfo}
					/>
				)}
			</div>
			{screen.lg && affixedMobileButtons}
			{/* Size 1x1 Ad */}
			<Ad
				slotId="size_1x1"
				sizes={[ [1, 1] ]}
				adUnit={`${ADS_NAME}_Listing/size_1x1`}
			/>
		</div>
	);

	return (
		<>
			<Header showSearchBar isSticky={!screen.lg && !sider} />

			{(noIndex || noFollow) && (
				<Head>
					<meta name="robots" content={!noIndex ? "nofollow" : "noindex, nofollow"} />
				</Head>
			)}
			{data?.searchFast?.data && data?.searchFast?.data?.length == 0 && (
				<ListingStructDataJson listings={data?.searchFast?.data} />
			)}

			{screen.lg && <TopBarFilters />}
			{!screen.lg && affixedMobileButtons}
			<div className={!map? "search-page-container" : "search-page-container-map search-page-container"}>
				{sider && <SiderBar sider={sider} setSider={setSider} map={map} />}
				<div
					className="search-results-content"
					style={
						map
							? {
								position: "sticky",
								top: "96px",
							}
							: {}
					}>
					{topContent}
					{map ? (
						<SearchResultsMap />
					) : (
						<>
							<Listings data={data} loading={loading} error={error} showExpenses={false} />
							<SearchResultsPagination
								error={error}
								loading={loading}
								paginatorInfo={data?.searchFast?.paginatorInfo}
							/>
						</>
					)}
				</div>
			</div>
			<Ad
				slotId="robapagina"
				classes={{ root: "listing-ad-container" }}
				adUnit={`${ADS_NAME}_Listing/Robapagina_Bottom`}
				sizes={[
					[300, 250],
					[300, 300],
					[728, 90],
				  ]}
				  sizeMapping={[
					[[1280, 0], [[728, 90]]],
					[[960, 0], []],
					[
					  [0, 0],
					  [
						[300, 250],
						[300, 300],
					  ],
					],
				  ]}
			/>
			{/* @TODO - sacar antd y refactor estos 3 componentes
			 */}
			{modal && country_code!=='CO' && <IcBuscaPorTi onClose={handleClose} showButtons />}
			{!map && <Footer />}
			{!map && <PicHomeFooter />}
		</>
	);
};
